import { createAction, props } from '@ngrx/store';
import { IProducts, IUpdateDMAAccountNumberRequest, IProductUpdateRequest } from '../models/products.model';

export const loadCurrentProducts = createAction('[CurrentProducts] Load CurrentProducts', props<{ request: string }>());

export const loadCurrentProductsSuccess = createAction(
  '[CurrentProducts] Load CurrentProducts Success',
  props<{ response: IProducts[] }>()
);

export const loadCurrentProductsFailure = createAction('[CurrentProducts] Load CurrentProducts Failure', props<{ error: Error | any }>());

export const loadUpcomingProducts = createAction('[CurrentProducts] Load upcoming Products', props<{ request: string }>());

export const loadUpcomingProductsSuccess = createAction('[CurrentProducts] Load upcoming Success', props<{ response: IProducts[] }>());

export const loadUpcomingProductsFailure = createAction('[CurrentProducts] Load upcoming Failure', props<{ error: Error | any }>());

// Update DMA Account Number
export const updateDMAAccountNumberRequest = createAction(
  '[UpdateDMAAccountNumber] Update DMA Account Number Request',
  props<{ productId: string; userProfileId: string; request: IUpdateDMAAccountNumberRequest }>()
);

export const updateDMAAccountNumberSuccess = createAction(
  '[UpdateDMAAccountNumber] Update DMA Account Number Success',
  props<{ response: string }>()
);

export const updateDMAAccountNumberFailure = createAction(
  '[UpdateDMAAccountNumber] Update DMA Account Number Failure',
  props<{ error: Error | any }>()
);

// Update Product
export const updateProductRequest = createAction(
  '[UpdateProduct] Update Product Request',
  props<{ customerId: string; productSavingsId: string; request: IProductUpdateRequest }>()
);

export const updateProductSuccess = createAction('[UpdateProduct] Update Product Success', props<{ response: string }>());

export const updateProductFailure = createAction('[UpdateProduct] Update Product Failure', props<{ error: Error | any }>());
